import { Banner, Checkbox, Modal, BlockStack, Text } from '@shopify/polaris';
import React, { useState, useEffect } from 'react';
import { DI, DIProps } from '../../../../Core';
import { useTranslation } from 'react-i18next';
interface Props extends DIProps {
    syncAction: (product_ids: string, operation: boolean) => void;
    syncModal: boolean;
    setsyncModal: (data: boolean) => void;
    actiontype: any;
    syncmodalLoading: boolean;
    totalProdCount: number;
    FiftyPlus: boolean;
    activePlan: string;
}

function SyncModal(props: Props) {
    const { t } = useTranslation();
    const {
        syncModal,
        syncAction,
        actiontype,
        syncmodalLoading,
        setsyncModal,
    } = props;

    const [check, setCheck] = useState<boolean>(false);

    useEffect(() => {
        setCheck(actiontype?.checked)
    }, [actiontype?.checked]);
    return (
        <Modal
            instant
            open={syncModal}
            onClose={() => setsyncModal(false)}
            title={t(actiontype.title)}
            primaryAction={{
                content: t(actiontype.actionName),
                onAction: () => {
                    syncAction(actiontype?.product_id, check);
                },
                loading: syncmodalLoading,
            }}
            secondaryActions={[
                {
                    content: t('Cancel'),
                    onAction: () => setsyncModal(false),
                },
            ]}>
            <Modal.Section>
                <BlockStack gap="200">
                    <Banner tone="info" title={t("Note")}>{t("When you unlink a product but wish to maintain automatic data synchronization between Amazon and the app, check the provided box. If you decide to discontinue synchronization for that product, leave the box unchecked. Remember, you can easily toggle Auto Sync on/off for unlinked products later, either individually or in bulk.")}</Banner>
                    <Checkbox
                        label={t("Auto Sync")}
                        helpText={t("Check this box to maintain Auto Sync functionality for the product even after unlinking.")}
                        checked={check}
                        onChange={() => {
                            setCheck((check: boolean) => !check);
                        }}
                    />
                </BlockStack>
            </Modal.Section>
        </Modal>
    );
}

export default DI(SyncModal);
